import { openStatusArr } from "../../toc/orderBook/obConstants";

// helper function to grop objects of an array based on a key
export const HObGroupBy = (array: Array<any>, key: string, split?: string) => {
	// Return the end result
	return array.reduce((result, currentValue, index) => {
		if (split && currentValue[key]) {
			// If an array already present for key, push it to the array. Else create an array and push the object
			(result[currentValue[key].split(split)[0]] = result[currentValue[key].split(split)[0]] || []).push(currentValue);
		} else {
			(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
			// (result[index] = result[index] || []).push(currentValue);
		}

		// Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
		return result;
	}, {}); // empty object is the initial value for result object
};

export const HObGroupByRange = (array: Array<any>, key1: string, key2: string, split?: string) => {
	// Return the end result
	return array.reduce((result, currentValue, index) => {
		if (split && currentValue[key1] && currentValue[key2]) {
			// If an array already present for key1, push it to the array. Else create an array and push the object
			(result[currentValue[key1].split(split)[0] + "-" + currentValue[key2].split(split)[0]] =
				result[currentValue[key1].split(split)[0] + "-" + currentValue[key2].split(split)[0]] || []).push(currentValue);
		} else {
			(result[currentValue[key1] + "-" + currentValue[key2]] = result[currentValue[key1] + "-" + currentValue[key2]] || []).push(currentValue);
			// (result[index] = result[index] || []).push(currentValue);
		}

		// Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
		return result;
	}, {}); // empty object is the initial value for result object
};
// helper function to group objects of an array based on status key with possible values defined in constants array
export const HOb2DGroupBy = (array: Array<any>, statKey: string, matchValArr = openStatusArr) => {
	//return 2d array with conditinal grouping
	return array.reduce(
		(arr: any, d: any) => {
			if (matchValArr.indexOf(d[statKey].toLowerCase()) >= 0) {
				arr[0] = [...arr[0], d];
			} else {
				arr[1] = [...arr[1], d];
			}
			return arr;
		},
		[[], []]
	);
};
